import { type FC } from 'react';

import { Box, Flex } from '@myphx-engineering/phx-design-system';
import {
    INSURANCE_OFFER_PRIORITY,
    SELF_PAY_OFFER_PRIORITY,
    isInsuranceOfferType,
    isSelfPayOfferType,
} from '@phx/data-sources/medication-marketplace';

import { useFillPrescription } from '../../../../contexts/fill/use-fill-prescription';
import { usePathwayOverride } from '../../../../hooks/use-pathway-override';
import { getBestOffer } from '../../../../hooks/use-prescription-offers';

import { SelectInsurancePathCard } from './SelectInsurancePathCard';
import { SelectSelfPayPathCard } from './SelectSelfPayPathCard';

export const SelfPayPathSelectionCards: FC = () => {
    const { allOffers, medication } = useFillPrescription();
    const pathwayOverride = usePathwayOverride(medication);

    const selfPayOffers = allOffers.filter((offer) =>
        isSelfPayOfferType(offer.headlinePriceType)
    );
    const insuranceOffers = allOffers.filter((offer) =>
        isInsuranceOfferType(offer.headlinePriceType)
    );

    const bestSelfPayOffer = getBestOffer(
        selfPayOffers,
        SELF_PAY_OFFER_PRIORITY
    );
    const bestInsuranceOffer = getBestOffer(
        insuranceOffers,
        INSURANCE_OFFER_PRIORITY
    );

    if (pathwayOverride?.favoredPathway === 'insurance') {
        return (
            <Flex gap="xs">
                <Box flex={1}>
                    <SelectInsurancePathCard offer={bestInsuranceOffer} />
                </Box>
                <Box flex={1}>
                    <SelectSelfPayPathCard offer={bestSelfPayOffer} />
                </Box>
            </Flex>
        );
    }

    return (
        <Flex gap="xs">
            <Box flex={1}>
                <SelectSelfPayPathCard offer={bestSelfPayOffer} />
            </Box>
            <Box flex={1}>
                <SelectInsurancePathCard offer={bestInsuranceOffer} />
            </Box>
        </Flex>
    );
};
